import type { WavespeedModelConfig } from '../types';
import { clampTo, hasImageInput } from '../../tools';

export const nvidiaConfigs: Record<string, WavespeedModelConfig> = {
    'nvidia/cosmos-3-super/text-to-image': {
        // https://wavespeed.ai/zh-CN/models/nvidia/cosmos-3-super/text-to-image
        apiPath: '/nvidia/cosmos-3-super/text-to-image',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, providerOptions } = params;
            return {
                prompt: prompt,
                size: clampTo(aspectRatio || '1:1', ['16:9', '9:16', '4:3', '3:4', '1:1'] as const, '1:1'),
                // 可选参数
                negative_prompt: typeof providerOptions?.negative_prompt === 'string' ? providerOptions.negative_prompt : undefined,
                num_inference_steps: typeof providerOptions?.num_inference_steps === 'number' ? providerOptions.num_inference_steps : 28,
                guidance_scale: typeof providerOptions?.guidance_scale === 'number' ? providerOptions.guidance_scale : 4,
                output_format: clampTo(
                    providerOptions?.output_format || 'jpeg',
                    ['jpeg', 'png'] as const,
                    'jpeg',
                ),
            };
        },
    },
};